export interface SearcherLabels {
  toggle: string
  placeholder: string
  clearAriaLabel: string
  noResults: string
}

export const DEFAULT_SEARCHER_LABELS: SearcherLabels = {
  toggle: 'Search',
  placeholder: 'Search…',
  clearAriaLabel: 'Clear search',
  noResults: 'No matches.',
}
